import styled from 'styled-components';
import { grey } from 'styles/Colors';

export const TeamsWrapper = styled.div`
  display: flex;
  gap: 8px;
  align-items: flex-end;
`;

export const TeamLabel = styled.div`
  color: ${grey};
  font-family: Inter;
  font-size: 11px;
  font-weight: 600;
  line-height: 10px;
`;

export const TeamValue = styled.div`
  color: ${({ theme }) => theme.teamValueColor};
  font-family: Inter;
  font-size: 15px;
  font-weight: 600;
  line-height: 21px;
`;

export const BackButton = styled.div`
  background: ${({ theme }) => theme.backButtonBackgroundColor};
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border-radius: 4px;

  svg path {
    fill: ${({ theme }) => theme.backButtonIconFill};
  }
`;

export const ControlsWrapper = styled.div`
  display: flex;
  gap: 20px;
`;
